module.exports = __webpack_public_path__ + "static/media/DemoArrowFirst.0f68beb5.svg";